const AUTH_KEY = 'auth_data'

const StorageService = {
  getAuthdata () {
    const data = JSON.parse(localStorage.getItem(AUTH_KEY))
    return data
  },

  saveAuthdata (data, token) {
    const datas = { ...data, ...token }
    localStorage.setItem(AUTH_KEY, JSON.stringify(datas))
  },

  saveMenuList (data) {
    const datas = Object.assign({
      menus: data.menus
    })
    localStorage.setItem('menus', JSON.stringify(datas))
  },

  saveWorkflowList (data) {
    localStorage.setItem('workflow_list', JSON.stringify(data))
  },

  getWorkflowList () {
    const data = JSON.parse(localStorage.getItem('workflow_list'))
    return data
  },

  getMenuList () {
    const data = JSON.parse(localStorage.getItem('menus'))
    return data
  },

  removeAuthdata () {
    localStorage.removeItem(AUTH_KEY)
    localStorage.removeItem('menu_status')
    localStorage.removeItem('workflow_list')
  }
}

export { StorageService }
